
import {changeIfEmpty} from 
	"./../change/changeIfEmpty.js";

export function detectPressAndHold( obj={} ){

	/**** 
	 * THIS FUNCTION DETECTS WHEN A BUTTON/ELEMENT IS PRESSED AND THEN HELD FOR A GIVEN TIME
	 * 
	 * UPON DETECTING THIS, IT WILL CALL THE FUNCTION THAT WAS SPECIFIED TO BE CALLED
	 * 
	 * IF THE ELEMENT IS PRESSED AND HELD FOR THE GIVEN TIME
	 * 
	 * TWO FUNTIONS HAVE TO BE SPECIFIED 
	 * 	ONE FOR WHEN THE ELEMENT PRESSED AND HELD FOR THE GIVEN TIME
	 * 	ANOTHER FOR WHEN THE ELEMENT IS PRESSED BUT NOT HELD FOR THE GIVEN TIME
	 * 
	 * 	element -- CLASS NAME OR ID OF THE ELEMENT IT SHOULD BE WRITEN WITH . OR # FOR CLASS
	 * 		AND ID RESPECTIVELY 
	 * 
	 * 	requiredButtonPressTime -- HOW LONG THE ELEMENT SHOULD BE PRESSED BEFORE THE 
	 * 		pressHoldIsDetectedFunc FUNCTION FIRES
	 * 
	 * 	pressHoldIsDetectedFunc -- THE FUNCTION TO CALL WHEN THE ELEMENT IS PRESSED AND HELD FOR THE 
	 * 		SPECIFIED TIME (requiredButtonPressTime)
	 * 
	 * 	pressHoldIsNotDetectedFunc -- THE FUNCTION TO CALL WHEN THE ELEMENT IS PRESSED BUT NOT HELD FOR THE 
	 * 		SPECIFIED TIME (requiredButtonPressTime)
	 * 
	 *  ****/

	const requiredButtonPressTime = changeIfEmpty(obj.requiredButtonPressTime, 250);
	const element = obj.element;
	const pressHoldIsDetectedFunc = obj.pressHoldIsDetectedFunc;
	const pressHoldIsNotDetectedFunc = changeIfEmpty(obj.pressHoldIsNotDetectedFunc, ()=>{ return false});
	const timeIncrement = 100;

	let pressAndHoldTimeCounter = null;
	let pressedNumber = null;
	let howLongButtonWasPress = 0;
	
	let lastMouseDown = 500;
	let lastMouseDownCounter = 0;


	$("body").on("mousedown", element, ()=>{

		pressAndHoldTimeCounter = setInterval( ()=>{

			howLongButtonWasPress += timeIncrement;

			if(howLongButtonWasPress >= requiredButtonPressTime){

	    		pressHoldIsDetectedFunc();

	    		howLongButtonWasPress = 0;	
	    		lastMouseDown = 0;			

			};

		}, timeIncrement);

	});

	$("body").on("mouseup", element, ()=>{

		clearInterval(pressAndHoldTimeCounter);	
		clearInterval(lastMouseDownCounter);

		lastMouseDownCounter = setInterval( ()=>{

			lastMouseDown += timeIncrement;

			if(lastMouseDown >= requiredButtonPressTime){

				clearInterval(lastMouseDownCounter);

			};

		}, timeIncrement);	

		howLongButtonWasPress = 0;

		if(howLongButtonWasPress < requiredButtonPressTime & lastMouseDown >= requiredButtonPressTime){
			
    		pressHoldIsNotDetectedFunc();
    				
		};

	});

};
